<template>
  <div class="container">
    <div class="left-bg">
      <bubbleBg></bubbleBg>
    </div>
    <div class="right-content">
        <section class="window-btn row align-center">
          <div class="min-size cursor" @click="minWindow">
            <i class="el-icon-minus size-icon" :title="$t('login.minimize')"></i>
          </div>
          <div class="close-size cursor" @click="closeWindow">
            <i class="el-icon-close size-icon" :title="$t('login.close')"></i>
          </div>
        </section>
        <section class="login-section">
          <h1 class="login-title">{{ $t('login.welcomeTitle') }}</h1>
          <div class="phone-login" v-if="loginType === 'password'">
            <el-form ref="form" :model="form" :rules="loginType === 'password' ? rules : ''" @submit.native.prevent>
              <el-form-item prop="phone">
                <el-input ref="phone" maxlength="11" v-model="form.phone" :placeholder="$t('login.inputPhone')"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input ref="password" v-model="form.password" type="password" :placeholder="$t('login.inputPassword')"></el-input>
              </el-form-item>
              <div class="row space-between login-password">
                <el-checkbox v-model="remPassword" :label="$t('login.rememberPassword')"></el-checkbox>
              </div>
              <el-button class="submit-btn" native-type="submit" @click.native="submit" :loading="loading">
                {{ $t('login.loginBtn') }}
              </el-button>
              <div class="language-switch" @click="languageDialog = true">
                <i class="el-icon-s-opportunity"></i>
                <span>{{ $t('login.switchLanguage') }}</span>
              </div>
            </el-form>
          </div>
          <div class="login-code" v-if="loginType === 'code'">
            <div class="code-text">{{ $t('login.scanCodeTip') }}</div>
            <div class="code-image">
              <el-image :src="identifyBase64"></el-image>
              <div class="code-mask" v-if="Number(scanType) > 0">
                <template v-if="scanType === '1'">
                  <img class="success-img" src="../assets/images/createsucc.png" />
                  <div class="cursor success-btn">{{ $t('login.scanSuccessTip') }}</div>
                </template>
                <template v-if="scanType === '2'">
                  <img class="success-img" src="../assets/images/createsucc.png" />
                  <div class="success-btn">{{ $t('login.authorizing') }}</div>
                </template>
                <template v-if="scanType === '3'">
                  <div class="login-fail cursor">{{ $t('login.qrcodeExpired') }}</div>
                  <el-button class="fail-btn" type="info" @click="refreshCode">{{ $t('login.refreshQrcode') }}</el-button>
                </template>
                <template v-if="scanType === '4'">
                  <div class="login-fail cursor">{{ $t('login.loginFail') }}</div>
                  <el-button class="fail-btn" type="info" @click="refreshCode">{{ $t('login.refreshQrcode') }}</el-button>
                </template>
              </div>
            </div>
            <p>{{ $t('login.qrcodeExpireTime') }}{{ expireTime }}</p>
          </div>
        </section>
    </div>
   
    <!-- <div class="login-change">
      <img
        v-if="loginType === 'password'"
        class="login-change-img"
        src="../assets/images/code-login.png"
        @click="changeLogin('code')" />
      <img
        v-if="loginType === 'code'"
        class="login-change-img"
        src="../assets/images/phone-login.png"
        @click="changeLogin('password')" />
    </div> -->
    <section class="row align-center space-center login-mask" v-if="maskVisible">
      <div class="mask-box">
        <div>{{ deptCode }}/{{ deptName }}</div>
        <p>{{ $t('login.multiCashierTip') }}</p>
        <div
          class="row align-center table-line"
          v-for="(item, index) in terminalList"
          :key="index"
          :class="selectItem && selectItem.id === item.id ? 'select-line' : ''"
          @click="selectHandel(item)">
          <div class="row align-center space-center select-circle">
            <span></span>
          </div>
          <span class="line-title">{{ item.title }}</span>
        </div>
        <el-checkbox v-model="rememberSelect" :label="$t('login.rememberSelection')"></el-checkbox>
        <div class="mask-sure cursor" @click="joinHandel">{{ $t('login.confirmEnter') }}</div>
      </div>
    </section>
    <div class="pro-dev" @click="apiDialog = true"></div>
    <section class="row align-center space-center api-mask" v-if="languageDialog">
      <div class="language-dialog">
        <div class="title-row row align-center space-between">
          <p class="row align-center">
            <i></i>
            <span>{{ $t('login.switchLanguage') }}</span>
          </p>
          <i class="el-icon-close" @click="languageDialog = false"></i>
        </div>
        <div class="language-options">
          <div
            class="language-item row align-center"
            :class="{ selected: currentLanguage === 'zh' }"
            @click="selectLanguage('zh')">
            <div class="radio-circle row align-center space-center">
              <span></span>
            </div>
            <div class="flag-icon flag-cn"></div>
            <span class="language-text">中文（简体）/ Chinese(Simplified)</span>
          </div>
          <!-- <div
            class="language-item row align-center"
            :class="{ selected: currentLanguage === 'en' }"
            @click="selectLanguage('en')">
            <div class="radio-circle row align-center space-center">
              <span></span>
            </div>
            <div class="flag-icon flag-us"></div>
            <span class="language-text">英文 / English</span>
          </div> -->
          <div
            class="language-item row align-center"
            :class="{ selected: currentLanguage === 'vn' }"
            @click="selectLanguage('vn')">
            <div class="radio-circle row align-center space-center">
              <span></span>
            </div>
            <div class="flag-icon flag-vn"></div>
            <span class="language-text">越南语 / Vietnamese / Tiếng Việt</span>
          </div>
        </div>
        <el-button type="primary" size="medium" @click="confirmLanguage">{{ $t('login.confirm') }}</el-button>
      </div>
    </section>
    <section class="row align-center space-center api-mask" v-if="apiDialog">
      <div class="chang-dialog">
        <div class="title-row row align-center space-between">
          <p class="row align-center">
            <i></i>
            <span>{{ $t('login.envSetting') }}</span>
          </p>
          <i
            class="el-icon-close"
            @click="
              apiDialog = false
              passwordStep = true
              apiPassword = ''
            "></i>
        </div>
        <div class="password-box" v-if="passwordStep">
          <input class="input" :placeholder="$t('login.inputPasswordTip')" v-model="apiPassword" size="small" @keyup.enter="stepChange" />
        </div>
        <div class="row align-center label" v-else>
          <span>{{ $t('login.envSelect') }}</span>
          <div :class="[apiType === '1' ? 'select' : '']" @click="apiType = '1'">
            <span>{{ $t('login.prodEnv') }}</span>
            <i v-show="apiType === '1'" class="el-icon-check"></i>
          </div>
          <div :class="[apiType === '2' ? 'select' : '']" @click="apiType = '2'">
            <span>{{ $t('login.preEnv') }}</span>
            <i v-show="apiType === '2'" class="el-icon-check"></i>
          </div>
        </div>
        <el-button type="primary" size="medium" @click="stepChange">{{ $t('login.confirm') }}</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import tool from '@/utils/tool.js'
import moment from 'moment'
import bubbleBg from '@/components/bubbleBg.vue'
import { ipcApiRoute } from '@/api/main'
import { ipc } from '@/utils/ipcRenderer'
import { queryTerminalInfo } from '@/libs/http/modules/posOrder'
import { Login, getOauthScan, oauthScanPreLogin } from '@/libs/http/api.js'
const urlConfig = window.urlConfig
export default {
  components: {
    bubbleBg
  },
  data() {
    return {
      form: {
        phone: '',
        password: ''
      },
      rules: {
        password: [{ required: true, trigger: 'blur', message: this.$t('login.inputPasswordRequired') }],
        phone: [{ required: true, trigger: 'blur', message: this.$t('login.validPhone'), max: 11 }]
      },
      timer: null,
      scanType: '',
      deptName: '',
      deptCode: '',
      identify: '',
      loading: false,
      expireTime: '',
      terminalList: [],
      selectItem: null,
      maskVisible: false,
      identifyBase64: '',
      remPassword: false,
      loginType: 'password',
      rememberSelect: false,
      passwordStep: true,
      apiDialog: false,
      apiType: '',
      apiPassword: '',
      languageDialog: false,
      currentLanguage: 'zh'
    }
  },
  mounted() {
    document.title = this.$t('login.loginBtn')
    if (this.form.phone === '') {
      this.$refs.phone.focus()
    } else {
      this.$refs.password.focus()
    }
    if (this.$cache.local.get('remember') === 'Y') {
      this.remPassword = true
      this.form.phone = this.$cache.local.get('phone')
      this.form.password = this.$cache.local.get('password')
    } else {
      this.form.password = ''
      this.remPassword = false
    }
    // 初始化当前语言
    // this.currentLanguage = localStorage.getItem('locale') || 'zh'
    this.currentLanguage = this.$cache.local.get('locale') || 'zh'
  },
  methods: {
    minWindow() {
      ipc.invoke(ipcApiRoute.actionMainWindow, 'mini').then(r => {})
    },
    closeWindow() {
      ipc.invoke(ipcApiRoute.actionMainWindow, 'close').then(r => {})
    },
    changeLogin(type) {
      this.loginType = type
      if (type === 'code') {
        this.getCode()
      } else {
        this.scanType = '0'
        clearInterval(this.timer)
        this.timer = null
      }
    },
    getCode() {
      getOauthScan()
        .then(data => {
          this.identify = data.identify
          this.identifyBase64 = data.identifyBase64
          this.expireTime = data.expireTime
          this.timer = setInterval(() => {
            this.getScanState()
          }, 2000)
        })
        .catch(err => {
          this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
        })
    },
    getScanState() {
      if (moment().isAfter(moment(this.expireTime))) {
        this.scanType = '3'
        clearInterval(this.timer)
        this.timer = null
        return
      }
      oauthScanPreLogin({ qrcode: this.identify })
        .then(data => {
          if (data.state === '0') {
            this.scanType = '0'
          }
          if (data.state === '1') {
            this.scanType = '1'
          }
          if (data.state === '2') {
            this.form.phone = data.phone
            clearInterval(this.timer)
            this.timer = null
            this.scanType = '2'
            this.login()
          }
        })
        .catch(err => {
          this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
        })
    },
    refreshCode() {
      this.scanType = '0'
      this.getCode()
    },
    submit() {
      // this.$cache.local.set('isRevenue', 'Y')
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.login()
        }
      })
    },
    login() {
      this.loading = true
      const reqData = {
        phone: this.form.phone
      }
      if (this.loginType === 'code') {
        reqData['loginType'] = '2'
        reqData['qrcode'] = this.identify
      } else {
        reqData['password'] = this.form.password
      }
      Login(reqData)
        .then(data => {
          //重新登录时清除新接口的token和登录时效
          tool.data.remove('TOKEN')
          tool.data.remove('TOKEN_TIME')

          this.loading = false
          this.$cache.local.set('token', data['accessToken'])
          this.$cache.local.set('wsToken', data['wsToken'])
          this.$cache.local.set('deptId', data['deptId'])
          this.$cache.local.set('deptName', data['deptName'])
          this.$cache.local.set('deptCode', data['erpShopAlias'])
          this.$cache.local.set('saleQuality', data['saleQuality'])
          this.$cache.local.set('marketingUnitId', data['marketingUnitId'])
          this.$cache.local.set('routeList', JSON.stringify(data['permissions']))
          this.$cache.local.set('name', data['name'])
          this.$cache.local.set('phone', data['phone'])
          this.$cache.local.set('userId', data['userId'])
          this.$cache.local.set('avatar', data['avatar'])
          this.$cache.local.set('password', this.form.password)
          if (this.remPassword) {
            this.$cache.local.set('remember', 'Y')
          } else {
            this.$cache.local.set('remember', 'N')
          }
          this.$cache.local.set('maxCount', data['maxCount'])
          this.$cache.local.set('intervalTime', data['intervalTime'])
          this.$cache.local.set('deptReturnCode', data['postPrintInfo']['deptReturnCode'] || 'DPTCD')
          this.$cache.local.set('deptReturnCount', data['postPrintInfo']['deptReturnCount'] || '1')
          this.$cache.local.set('deptAllotCode', data['postPrintInfo']['deptAllotCode'] || 'DPDCD')
          this.$cache.local.set('packageCode', data['postPrintInfo']['deptReturnPackageCode'] || 'DPTCD_BG')
          this.$cache.local.set('packageCount', data['postPrintInfo']['deptReturnPackageCount'] || '1')
          this.$cache.local.set('deptAllotPackageCode', data['postPrintInfo']['deptAllotPackageCode'] || 'DPDBD_BG')
          this.$cache.local.set('deptAllotPackageCount', data['postPrintInfo']['deptAllotPackageCount'] || '1')
          this.$cache.local.set('deptAllotCount', data['postPrintInfo']['deptAllotCount'] || '1')
          this.$cache.local.set('printerModel', data['postPrintInfo']['printerModel'] || 'XP-80C')
          this.$cache.local.set('retailReceiptCode', data['postPrintInfo']['retailReceiptCode'] || 'LSXP')
          this.$cache.local.set('retailReceiptCount', data['postPrintInfo']['retailReceiptCount'] || '1')
          this.$cache.local.set('crmReceiptCode', data['postPrintInfo']['crmReceiptCode'] || 'HYXP')
          this.$cache.local.set('crmReceiptCount', data['postPrintInfo']['crmReceiptCount'] || '1')
          this.$cache.local.set('kdReceiptCode', data['postPrintInfo']['kdReceiptCode'] || 'KDXP')
          this.$cache.local.set('kdReceiptCount', data['postPrintInfo']['kdReceiptCount'] || '1')
          this.$cache.local.set('skuLableReceiptCode', data['postPrintInfo']['skuLableReceiptCode'] || 'SKU-LABLE')
          this.$cache.local.set('skuLableReceiptCount', data['postPrintInfo']['skuLableReceiptCount'] || '1')
          this.$cache.local.set('tjtzReceiptCode', data['postPrintInfo']['tjtzReceiptCode'] || 'TJTZ')
          this.$cache.local.set('tjtzReceiptCount', data['postPrintInfo']['tjtzReceiptCount'] || '1')
          //店铺退仓包裹外箱单打印
          this.$cache.local.set('deptReturnPackageWDCode', data['postPrintInfo']['deptReturnPackageWDCode'] || 'DPTCD_BG_WD')
          this.$cache.local.set('deptReturnPackageWDCount', data['postPrintInfo']['deptReturnPackageWDCount'] || '1')
          this.$cache.local.set('deptAllotPackageWDCode', data['postPrintInfo']['deptAllotPackageWDCode'] || 'DPDBD_BG_WD')
          this.$cache.local.set('deptAllotPackageWDCount', data['postPrintInfo']['deptAllotPackageWDCount'] || '1')
          this.$cache.local.set('enableNewOaFlag', data['enableNewOaFlag'] || '0')
          this.deptName = this.$cache.local.get('deptName')
          this.deptCode = this.$cache.local.get('deptCode')
          queryTerminalInfo({
            id: data['marketingUnitId']
          })
            .then(res => {
              if (res && JSON.stringify(res) !== '{}' && res.length > 1) {
                this.terminalList = res
                this.maskHandel()
              } else {
                if (res && res[0]) {
                  this.$cache.local.set('cashierDeskItem', JSON.stringify(res[0]))
                } else {
                  this.$cache.local.set('cashierDeskItem', JSON.stringify(''))
                }
                this.$router.replace('/home')
                setTimeout(() => {
                  ipc.invoke(ipcApiRoute.actionMainWindow, 'max').then(r => {})
                }, 100)
              }
            })
            .catch(error => {
              this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
            })
        })
        .catch(err => {
          this.loading = false
          this.scanType = '4'
          this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
        })
    },
    selectHandel(item) {
      this.selectItem = item
    },
    maskHandel() {
      this.maskVisible = true
      let rememberKey = this.$cache.local.get('rememberSelect')
      if (rememberKey) {
        rememberKey = JSON.parse(this.$cache.local.get('rememberSelect'))
      }
      let remItem = {}
      if (this.$cache.local.get('cashierDeskItem')) {
        remItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
      }
      let res = this.terminalList.some(item => {
        return item.id === remItem.id && item.title === remItem.title
      })
      if (rememberKey && res) {
        this.selectItem = remItem
        this.rememberSelect = rememberKey
      } else {
        this.selectItem = null
        this.rememberSelect = false
      }
    },
    joinHandel() {
      if (!this.selectItem) {
        return this.$message({ type: 'error', message: this.$t('login.selectCashier'), duration: 2000, showClose: true })
      }
      this.$cache.local.set('cashierDeskItem', JSON.stringify(this.selectItem))
      this.$cache.local.set('rememberSelect', JSON.stringify(this.rememberSelect))
      this.$router.replace('/home')
      setTimeout(() => {
        ipc.invoke(ipcApiRoute.actionMainWindow, 'max').then(r => {})
      }, 100)
    },
    stepChange() {
      const that = this
      if (this.passwordStep) {
        if (this.apiPassword !== '666888')
          return this.$message({
            type: 'error',
            message: this.$t('login.correctDevPassword'),
            duration: 2000,
            showClose: true
          })
        this.apiPassword = ''
        this.passwordStep = false
        ipc
          .invoke(ipcApiRoute.fileCacheGet, {
            cacheName: 'INJECT_ENV'
          })
          .then(r => {
            if (r) {
              if (r === 'production') {
                that.apiType = '1'
              } else {
                that.apiType = '2'
              }
            } else {
              that.apiType = '1'
            }
          })
      } else {
        if (this.apiType === '1') {
          ipc
            .invoke(ipcApiRoute.fileCacheSet, {
              cacheName: 'INJECT_ENV',
              cacheValue: 'production'
            })
            .then(r => {
              if (r) {
                window.location.href = urlConfig.prodPosWebRoot
                ipc.invoke(ipcApiRoute.setDomainName, urlConfig.prodPosWebRoot).then(r => {})
              } else {
                this.$message({
                  type: 'error',
                  message: this.$t('login.envSwitchError'),
                  duration: 2000,
                  showClose: true
                })
              }
            })
        } else {
          ipc
            .invoke(ipcApiRoute.fileCacheSet, {
              cacheName: 'INJECT_ENV',
              cacheValue: 'pre'
            })
            .then(r => {
              if (r) {
                window.location.href = urlConfig.prePosWebRoot
                ipc.invoke(ipcApiRoute.setDomainName, urlConfig.prePosWebRoot).then(r => {})
              } else {
                this.$message({
                  type: 'error',
                  message: this.$t('login.envSwitchError'),
                  duration: 2000,
                  showClose: true
                })
              }
            })
        }
        this.apiDialog = false
        this.passwordStep = true
      }
    },
    selectLanguage(lang) {
      this.currentLanguage = lang
    },
    confirmLanguage() {
      // localStorage.setItem('locale', this.currentLanguage)
      this.$cache.local.set('locale', this.currentLanguage)
      this.$i18n.locale = this.currentLanguage
      this.languageDialog = false
      // 更新窗口标题为当前语言
      document.title = this.$t('login.loginBtn')
      this.rules = {
         password: [{ required: true, trigger: 'blur', message: this.$t('login.inputPasswordRequired') }],
         phone: [{ required: true, trigger: 'blur', message: this.$t('login.validPhone'), max: 11 }]
      }
      this.$message({
        type: 'success',
        message: this.$t('login.languageSwitchSuccess'),
        duration: 2000,
        showClose: true
      })
    }
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style>
.login-section .el-input__inner {
  border: none;
  background: #f6f7fb;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  border-radius: 8px;
  margin-top: 20px;
}
</style>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: #fff;
  // background: url('../assets/images/login_bg.jpg');
  background-size: 100% 100%;
  position: relative;
  -webkit-app-region: drag;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .left-bg {
    width: 57%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .right-content {
    width: 43%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .window-btn {
    -webkit-app-region: no-drag;
    position: absolute;
    right: 0;
    top: 0;
    padding: 20px;

    .min-size {
      margin-right: 20px;
    }

    .size-icon {
      color: #999;
      font-size: 21px;
    }
  }

  .login-section {
    position: absolute;
    right: 8%;
    top: 20%;
    width: 400px;
    text-align: center;
    -webkit-app-region: no-drag;

    .login-title {
      font-size: 32px;
      letter-spacing: 3px;
      margin-bottom: 40px;
      height: 86px;
      color: #067cf2;
      font-weight: normal;
      font-family: 'font-Medium';
    }

    .phone-login {
      background: #ffffff;
      width: 350px;
      margin: auto;

      .submit-btn {
        font-family: 'font-Medium';
        width: 100%;
        border-radius: 6px;
        height: 50px;
        font-size: 20px;
        background: #067cf2;
        border: none;
        color: #fff;
        margin-top: 40px;
      }

      .login-password {
        .forget {
          color: #067cf2;
        }
      }

      .language-switch {
        margin-top: 20px;
        text-align: center;
        color: #067cf2;
        cursor: pointer;
        font-size: 14px;

        i {
          margin-right: 5px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .login-code {
      text-align: center;
      width: 350px;
      margin: auto;

      .code-text {
        font-size: 16px;
        color: #999;
      }

      .code-image {
        font-size: 0;
        width: 160px;
        height: 160px;
        margin: 50px auto 0;
        position: relative;

        .code-mask {
          position: absolute;
          width: 161px;
          height: 161px;
          background: rgba(0, 0, 0, 0.7);
          top: 0;
          right: 0;
          font-size: 14px;

          .success-img {
            width: 50px;
            height: 50px;
            margin: 20px auto;
          }

          .success-btn {
            color: #fff;
            margin: 0 10px;
          }

          .login-fail {
            color: #fff;
            margin: 35px auto 30px;
          }

          .fail-btn {
            background: #6590dc;
            border: none;
          }
        }
      }

      p {
        margin-top: 50px;
        color: #666;
      }
    }
  }

  .login-change {
    position: absolute;
    bottom: 10px;
    right: 10px;

    .login-change-img {
      width: 70px;
      height: 70px;
      -webkit-app-region: no-drag;
      cursor: pointer;
    }
  }

  .login-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;

    .mask-box {
      -webkit-app-region: no-drag;
      background: #fff;
      padding: 20px;
      border-radius: 6px;

      > p {
        margin: 10px 0 40px;
      }

      .table-line {
        border: 1px solid #ddd;
        height: 46px;
        padding: 0 10px;
        border-radius: 6px;
        margin-bottom: 10px;
        cursor: pointer;

        .select-circle {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid #ddd;
          margin-right: 10px;
        }

        .line-title {
          margin-top: -2px;
        }
      }

      .select-line {
        border: 1px solid #067cf2;
        background: rgb(230, 247, 255);

        .select-circle {
          border: 1px solid #067cf2;

          span {
            background: #067cf2;
            width: 14px;
            height: 14px;
            border-radius: 50%;
          }
        }
      }

      .mask-sure {
        background: #067cf2;
        border-radius: 6px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        width: 260px;
        margin: 50px auto 0;
      }
    }
  }

  .pro-dev {
    width: 120px;
    height: 70px;
    position: fixed;
    left: 30px;
    top: 68px;
    cursor: pointer;
    -webkit-app-region: no-drag;
  }

  .api-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .chang-dialog {
    -webkit-app-region: no-drag;
    background: #fff;
    text-align: center;
    border-radius: 8px;
    width: 350px;
    height: 250px;

    .title-row {
      border-radius: 8px 8px 0 0;
      background: #f5f5f5;
      padding: 10px;

      p i {
        width: 5px;
        height: 22px;
        background: #0b83f3;
        margin-right: 10px;
        border-radius: 2px;
      }

      > i {
        font-size: 20px;
        cursor: pointer;
        color: #666;
      }
    }

    .password-box {
      height: 150px;
      line-height: 150px;

      .input {
        background: #f5f5f5;
        border: none;
        outline: none;
        line-height: 36px;
        padding: 0 10px;
        width: 320px;
      }
    }

    .label {
      height: 150px;
      line-height: 150px;

      > span {
        margin-left: 15px;
        line-height: normal;
      }

      i {
        margin-left: 5px;
        font-weight: bold;
      }

      div {
        padding: 12px 10px;
        cursor: pointer;
        line-height: normal;
        border: 1px solid #eee;
        margin-right: 10px;
        border-radius: 4px;
      }

      .select {
        border: 1px solid #0b83f3;
        color: #0b83f3;
      }
    }
  }

  .language-dialog {
    -webkit-app-region: no-drag;
    background: #fff;
    text-align: center;
    border-radius: 8px;
    width: 500px;
    padding-bottom: 30px;

    .title-row {
      border-radius: 8px 8px 0 0;
      background: #f5f5f5;
      padding: 15px;

      p i {
        width: 5px;
        height: 22px;
        background: #0b83f3;
        margin-right: 10px;
        border-radius: 2px;
      }

      > i {
        font-size: 20px;
        cursor: pointer;
        color: #666;
      }
    }

    .language-options {
      padding: 30px 40px;
      text-align: left;

      .language-item {
        padding: 15px;
        border: 2px solid #e5e5e5;
        border-radius: 8px;
        margin-bottom: 15px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          border-color: #067cf2;
        }

        &.selected {
          border-color: #067cf2;
          background: rgb(230, 247, 255);

          .radio-circle {
            border-color: #067cf2;

            span {
              background: #067cf2;
              width: 12px;
              height: 12px;
              border-radius: 50%;
            }
          }
        }

        .radio-circle {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 2px solid #ddd;
          margin-right: 15px;
          flex-shrink: 0;
        }

        .flag-icon {
          width: 32px;
          height: 24px;
          margin-right: 12px;
          flex-shrink: 0;
          border-radius: 2px;
          border: 1px solid #e5e5e5;
        }

        .flag-cn {
          background: linear-gradient(to bottom, #de2910 0%, #de2910 100%);
          position: relative;

          &::before {
            content: '★';
            position: absolute;
            left: 6px;
            top: 4px;
            color: #ffde00;
            font-size: 10px;
          }
        }

        .flag-us {
          background: linear-gradient(
            to bottom,
            #b22234 0%,
            #b22234 7.69%,
            white 7.69%,
            white 15.38%,
            #b22234 15.38%,
            #b22234 23.07%,
            white 23.07%,
            white 30.76%,
            #b22234 30.76%,
            #b22234 38.45%,
            white 38.45%,
            white 46.14%,
            #b22234 46.14%,
            #b22234 53.83%,
            white 53.83%,
            white 61.52%,
            #b22234 61.52%,
            #b22234 69.21%,
            white 69.21%,
            white 76.9%,
            #b22234 76.9%,
            #b22234 84.59%,
            white 84.59%,
            white 92.28%,
            #b22234 92.28%,
            #b22234 100%
          );
          position: relative;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 40%;
            height: 50%;
            background: #3c3b6e;
          }
        }

        .flag-vn {
          background: #da251d;
          position: relative;

          &::before {
            content: '★';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #ffff00;
            font-size: 14px;
          }
        }

        .language-text {
          font-size: 15px;
          color: #333;
        }
      }
    }

    .el-button {
      width: 200px;
      height: 40px;
      font-size: 16px;
    }
  }
}
</style>